import styled from 'styled-components'
import { device } from '../../styles/GlobalVariables'
import Link from '../Link/Link'

export const VodButton = styled.div`
  display: inline-flex;
  background: #0a0c18;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #fff;
  //background: linear-gradient(
  //  135deg,
  //  rgba(255, 105, 176, 1) 30%,
  //  rgba(253, 52, 147, 1) 36%
  //);

  svg {
    height: 60%;
  }
`

export const VodButtonLink = styled(Link)`
  width: 51px;
  height: 23px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  ${device.medium} {
    width: 72px;
    height: 30px;
  }
`
